// @flow
import React, {Fragment} from 'react';
import { connect } from 'react-redux';
import styles from './relationListDisplay.css';
import DataTable from '../../DataTable';
import HighlightColumn from '../../DataTable/Columns/Highlight';
import TextColumn from '../../DataTable/Columns/Text';
import ButtonColumn from '../../DataTable/Columns/Button';
import {
  MdClose,
  MdArchive, MdDirections, MdDelete,
} from 'react-icons/lib/md';
type CreateUserFormPropTypes = {
  relations: Array<Object>,
  onChange: Function,
};

const RelationListDisplay = ({
  relations = [],
  onChange,
}: CreateUserFormPropTypes) => {
  let render = null;
  if (relations.length > 0) {
    render = (
      <DataTable
        className={styles.table}
        data={relations}
        columns={
          [
            HighlightColumn({ Header: 'Nombres', accessor: 'first_name', maxWidth: 150 }),
            HighlightColumn({ Header: 'Apellidos', accessor: 'last_name', maxWidth: 150 }),
            TextColumn({ Header: 'Teléfono', accessor: 'phone' }),
            TextColumn({ Header: 'Correo', accessor: 'email' }),
            ButtonColumn({
              accessor: 'actionProps',
              getOnClick: (params: { id: number }) => () => {
                onChange(relations.filter(e => e.id !== params.id));
              },
              buttonProps: {
                Icon: MdClose,
                siz: 32,
                isOutlined: true,
                isTransparent: true,
                size: 'medium ',
                tint: 'gray',
              },
              maxWidth: 50,
            }),
          ]
        }
        minRows={0}
        showPagination={false}
      />
    );
  } else {
    render = (
      <div className={styles.contactListPlaceholder}>
        <div className={styles.placeholderContent}>
          <MdArchive className={styles.icon} size={128} />
          <h3 className={styles.placeholderText}>
            El estudiante se creará con contactos asociados a el.
          </h3>
        </div>
      </div>
    );
  }
  return render;
};

const RelationListDisplayComponent = connect(
  undefined,
  undefined,
)(RelationListDisplay);

export default RelationListDisplayComponent;



// WEBPACK FOOTER //
// ./src/scripts/components/RelationGridInput/RelationListDisplay/index.jsx